import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Typography,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {ExpandMore} from '@material-ui/icons';
import React, {useState, useContext} from 'react';
import {toSnakeCase} from 'components/forms/locale/utils';
import {PositionCard, PositionCardForm} from 'components/forms';
import {FormState} from 'components/forms/context';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {ConfirmPrompt} from 'components/forms/Prompt';
import {StandAloneVesselCard} from './vessel/VesselCard';
import Show from 'components/utils/Show';
import {useGetVessel} from 'hooks/useGetEndpoint';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.gray.light,
    },
    details: {
        display: 'block',
    },
}));

const loopName = 'vessel_entries';

const ModifyVesselButtons = ({index, vesselName}) => {
    const [showConfirmPrompt, setShowConfirmPrompt] = useState(false);
    const {navigateToNamedLoop, deleteNamedLoop} = useContext(FormState);

    const editLoop = () => {
        navigateToNamedLoop(loopName, index);
    };

    const openConfirmPrompt = () => {
        setShowConfirmPrompt(true);
    };

    const hideConfirmPrompt = () => {
        setShowConfirmPrompt(false);
    };

    const deleteLoop = () => {
        deleteNamedLoop(loopName, index);
        hideConfirmPrompt();
    };

    if (!vesselName) {
        return null;
    }
    return (
        <Grid item container alignItems='center' style={{marginBottom: '1em'}}>
            <Grid item style={{flexGrow: '1'}}>
                <Button
                    fullWidth
                    color='primary'
                    variant='contained'
                    onClick={editLoop}
                >
                    Edit {vesselName}
                </Button>
            </Grid>
            <Grid item>
                <IconButton
                    color='secondary'
                    variant='contained'
                    onClick={openConfirmPrompt}
                    aria-label={`Delete ${vesselName}`}
                >
                    <DeleteForeverIcon />
                </IconButton>
            </Grid>
            <ConfirmPrompt
                open={showConfirmPrompt}
                description={`Are you sure you want to delete all experiences on ${vesselName}?`}
                onConfirm={deleteLoop}
                onCancel={hideConfirmPrompt}
            />
        </Grid>
    );
};

const VesselServicesCard = ({vesselData, index, inForm}) => {
    const classes = useStyles();
    const {vessel_id: vesselId} = vesselData;
    const {data: vessel, isLoading} = useGetVessel(vesselId);
    const ShowPosition = inForm ? PositionCardForm : PositionCard;
    const vesselName = vessel?.vessel_name || vesselData?.vessel_name;

    return [
        <Show condition={isLoading} key='loading'>
            <Accordion className={classes.root}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <CircularProgress />
                </AccordionSummary>
            </Accordion>
        </Show>,
        <Show condition={vesselName} key='vesselservices'>
            <Accordion className={classes.root}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls={`${toSnakeCase(vesselName)}-panel-control`}
                    id={`${toSnakeCase(vesselName)}-header`}
                >
                    <Typography variant='body1'>
                        <b>{vesselName}</b>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                    <StandAloneVesselCard
                        vesselId={vesselId}
                        vesselData={vesselData}
                    />
                    <Show condition={inForm}>
                        <ModifyVesselButtons
                            vesselName={vesselName}
                            index={index}
                        />
                    </Show>
                    <div style={{minHeight: '15px'}}></div>
                    {vesselData.service_entries?.map((position, posIndex) => (
                        <ShowPosition
                            key={posIndex}
                            position={position}
                            index={posIndex}
                        />
                    ))}
                </AccordionDetails>
            </Accordion>
        </Show>,
    ];
};

export default VesselServicesCard;
